import React from 'react'
import useReduxData from './useReduxData';
import incrementItemData from '../utils/Increment';
import useAppDispatch from './useAppDispatch';
import { SETCARTCOUNT, SETCARTTOTALPRICE } from '../redux/features/CartData';
import { CheckIsAddOnMatch, CheckIsSelectedCategory, CheckIsSelectedOptions } from '../utils/common/common.utils';
const useCartData = () => {
    const redux_data = useReduxData();
    const { cartData: { items, itemCount } } = redux_data;
    const dispatch = useAppDispatch()


    // check customize items qith all
    const FilterItemWithId = (data?: any, selectVariation?: any) => {
        // const filteredItem = items?.filter((i: any) => i.item_id && data.item_id);
        const filteredItem = items?.filter((i: any) => {
            if (i.item_id && data.item_id && (selectVariation ? i?.selected_variation?.variation_id == selectVariation?.variation_id && i?.selected_variation?.id == selectVariation?.id : true)) {
                return i;
            }
        })
        return filteredItem
    }

    const CheckCustomizeItems = (data: any, selectedVariation?: any, addOnData?: any, selectedoptions?: any, selectedCategory?: any, quantity?: any) => {
        if (items.length == 0) {
            return false;
        }

        const filteredItem = FilterItemWithId(data, selectedVariation) //items?.filter((i:any)=>i.item_id && data.item_id);
        // console.log("_filteredItem", items, data, selectedVariation, filteredItem)
        if (filteredItem?.length > 0) {
            const filterMatched = filteredItem?.filter((i: any) => {
                if (CheckIsAddOnMatch(i.selected_addOn, addOnData) == true && CheckIsSelectedOptions(i.selectedoptions, selectedoptions) == true && CheckIsSelectedCategory(i?.selectedCategory, selectedCategory)) {
                    return i;
                }
            })
            // console.log("_filterMatched", filteredItem, filterMatched, items, selectedVariation, addOnData, selectedoptions, selectedCategory)

            if (filterMatched?.length > 0) {
                incrementItemData(
                    filterMatched[0],
                    items,
                    dispatch,
                    itemCount,
                    filterMatched[0],
                    (quantity || 1)
                )
                return true;
            } else {
                return false;
            }

        } else {
            return false;
        }
    }

    //item with addons and withoutbaddons
    const CheckItemWithAddons = (data?: any, addOnData?: any, quantity?: any) => {
        if (items?.length == 0) {
            return false;

        }
        const findItems = items.filter((i: any) => i.item_id == data.item_id);
        if (findItems) {
            const filterMatched = findItems?.filter((i: any) => {
                if (CheckIsAddOnMatch(i.selected_addOn, addOnData)) {
                    return i;
                }
            })
            if (filterMatched?.length > 0) {
                incrementItemData(
                    filterMatched[0],
                    items,
                    dispatch,
                    itemCount,
                    filterMatched[0],
                    (quantity || 1)
                )
                return true;
            }
        } else {

            return false;
        }
    }

    // @@ check variation and variation + addons 
    const CheckVariationItemExist = (data?: any, addOnData?: any, quantity?: any) => {

        // console.log("_data", items, data, addOnData)

        if (items?.length == 0) {
            return false;
        }

        const findItems = items.filter((i: any) => i.item_id == data.item_id && i?.selected_variation?.variation_id == data?.variation_id && data?.id == i?.selected_variation?.id);

        if (findItems?.length > 0) {
            const filterMatched = findItems?.filter((i: any) => {
                if (CheckIsAddOnMatch(i.selected_addOn, addOnData)) {
                    return i;
                }
            })
            // console.log('_filterMatched', filterMatched)
            if (filterMatched?.length > 0) {
                incrementItemData(
                    filterMatched[0],
                    items,
                    dispatch,
                    itemCount,
                    filterMatched[0],
                    (quantity || 1)
                )
                return true;
            }
        }
        return false;

    }

    return {
        redux_data,
        cart_data: redux_data,
        CheckVariationItemExist,
        CheckItemWithAddons,
        CheckCustomizeItems
    }

}

export default useCartData

